import Vue from 'vue';
import VueAvatar from 'vue-avatar';
Vue.component('vue-avatar', VueAvatar);
